var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagGb = function SvgFlagGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "#fff",
    rx: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "#fff",
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0A17A7",
    d: "M0 0h22v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-1.008-1.533 8.38 4.915v-5.982h5.238v5.982l9.388-6.448L24.18.235l-7.423 5.098H22v5.334h-5.244l7.423 5.098-1.172 1.768-9.388-6.448v5.982H8.38v-5.982l-9.39 6.448-1.17-1.769 7.422-5.097H0V5.333h5.243L-2.18.235z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB1F35",
    strokeLinecap: "round",
    strokeWidth: 0.667,
    d: "M14.668 5.066 24.619-1.6M15.725 10.958l8.92 6.122M6.29 5.05l-9.306-6.386M7.299 10.883l-10.315 6.965"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6273E",
    fillRule: "evenodd",
    d: "M0 9.6h9.429V16h3.142V9.6H22V6.4h-9.429V0H9.43v6.4H0z",
    clipRule: "evenodd"
  }))));
};
export default SvgFlagGb;